import {
  FETCH_PARTICIPANTS_STARTED,
  FETCH_PARTICIPANTS_SUCCESS,
  FETCH_PARTICIPANTS_FAILED,
} from './participants.types';

// eslint-disable-next-line import/prefer-default-export
const participantsReducer = (
  state = {},
  { type, spaceId, participants, error }
) => {
  switch (type) {
    case FETCH_PARTICIPANTS_STARTED:
      return {
        ...state,
        [spaceId]: {
          ...state[spaceId],
          isLoading: true,
          error: null,
        },
      };
    case FETCH_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        [spaceId]: {
          isLoading: false,
          error: null,
          participants,
        },
      };
    case FETCH_PARTICIPANTS_FAILED:
      return {
        ...state,
        [spaceId]: {
          isLoading: false,
          error,
          participants: [],
        },
      };
    default:
      return state;
  }
};

export default participantsReducer;
